const TARGETS = [
  '.case-study-intro__inner',
  '.case-study-metrics__inner',
  '.case-study-gallery__inner',
  '.case-study-quote__inner',
  '.case-study-text__inner',
  '.shopify-section-case-study-content .section-content-wrapper',
].join(', ');

/** Holds the reveal back until the band is a little way into the viewport. */
const ROOT_MARGIN = '0px 0px -10% 0px';

/** Shared by every band on the page. @type {IntersectionObserver | null} */
let observer = null;

/**
 * Waits for an element to scroll into view, then reveals it once.
 *
 * @param {HTMLElement} element
 */
const watch = (element) => {
  observer ??= new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        if (entry.target instanceof HTMLElement) entry.target.dataset.reveal = 'visible';
        observer?.unobserve(entry.target);
      }
    },
    { rootMargin: ROOT_MARGIN }
  );

  observer.observe(element);
};

/**
 * Hides every band that has opted in, then hands it to the observer.
 *
 * @param {ParentNode} [root] - Limits the sweep, e.g. to the one section the
 *   theme editor has just re-rendered.
 */
const prepare = (root = document) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  for (const element of root.querySelectorAll(TARGETS)) {
    if (!(element instanceof HTMLElement)) continue;
    if (element.dataset.reveal) continue;

    // The timing custom property IS the opt-in — no timing, no reveal.
    if (!getComputedStyle(element).getPropertyValue('--case-reveal-duration').trim()) continue;

    element.dataset.reveal = 'pending';
    watch(element);
  }
};

prepare();

// The Section Rendering API swaps a section's HTML in place, and the
// replacement carries none of the state written above.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) prepare(event.target);
});
